import React, { useEffect } from "react";
import { connect } from "react-redux";
import { handleAuthenticationCallback } from "../_actions/auth-action";
import { useNavigate } from 'react-router-dom';
import { govHubSubPath } from '../utils/utils.js';
import PropTypes from 'prop-types';

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};
let Callback = ({ dispatch, user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const postLoginRedirect = localStorage.getItem("postLoginRedirect");
    const handleRedirect = async () => {
      // Dispatch to complete Auth0 callback
      await dispatch(handleAuthenticationCallback());
//The following was added due to a race condition, navigation was happening before the user was set in sessionStorage causing the login to get triggered twice. 
      const checkSessionStorage = () => {
        return new Promise((resolve) => {
          const intervalId = setInterval(() => {
            if (sessionStorage.getItem("user")) {
              clearInterval(intervalId);
              resolve();
            }
          }, 100); // Check every 100ms (adjust as needed)
        });
      };

      await checkSessionStorage(); // Wait for user in sessionStorage

      navigate(postLoginRedirect || `/${govHubSubPath}/my-dashboard`, { replace: true });
      localStorage.removeItem("postLoginRedirect");
    };

    handleRedirect();
  }, [dispatch, navigate]);

  return <div className="text-center">Loading user profile...</div>;
};

Callback = connect(mapStateToProps)(Callback);

Callback.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object
};

export default Callback;
